import { render } from "./purchaseReports.vue?vue&type=template&id=92404d78&scoped=true"
import script from "./purchaseReports.vue?vue&type=script&lang=js"
export * from "./purchaseReports.vue?vue&type=script&lang=js"

import "./purchaseReports.vue?vue&type=style&index=0&id=92404d78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92404d78"]])

export default __exports__